import React from 'react';
import styled from 'styled-components';

import { lighterBlue, lighterGrey } from '~theme';

const InnerButtons = props => {
  const {
    left,
    right,
    leftTitle,
    rightTitle,
    leftOnClick,
    rightOnClick,
    leftDisabled,
    rightDisabled,
    leftBgColor,
    rightBgColor,
  } = props;

  // Use either left or leftTitle, not both
  return (
    <Buttons>
      {left && <Button type="button">{left}</Button>}
      {leftTitle && (
        <Button type="button">
          <LeftButton
            disabled={leftDisabled}
            onClick={leftOnClick}
            bgColor={leftBgColor}
          >
            {leftTitle}
          </LeftButton>
        </Button>
      )}
      {right && <Button type="button">{right}</Button>}
      {rightTitle && (
        <Button type="button">
          <RightButton
            disabled={rightDisabled}
            onClick={rightOnClick}
            bgColor={rightBgColor}
          >
            {rightTitle}
          </RightButton>
        </Button>
      )}
    </Buttons>
  );
};

const MobileButtons = props => {
  const { controls } = props;
  const height = props.height || 75;

  return (
    <>
      <MarginForFixedWrapper height={height} />
      <FixedWrapper height={height}>
        {controls && <Controls>{controls}</Controls>}
        <InnerButtons {...props} />
      </FixedWrapper>
    </>
  );
};

const FixedWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: ${props => props.height}px;
  background-color: white;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  box-shadow: 0px -2px 6px #00000029;
`;

const MarginForFixedWrapper = styled.div`
  margin-top: ${props => props.height}px;
`;

const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Buttons = styled.div`
  display: flex;
  height: 100%;
  max-height: 75px;
`;

const Button = styled.button`
  outline: none;
  border: none;
  padding: 0;
  width: 100%;
  height: 100%;
  color: white;
`;

const MobileButton = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

const RightButton = styled(MobileButton)`
  background-color: ${props =>
    props.disabled ? lighterGrey : props.bgColor || lighterBlue};
`;

const LeftButton = styled(MobileButton)`
  background-color: ${props => props.bgColor || lighterGrey};
`;

export default MobileButtons;
